import React, { useRef } from 'react';
import { animate, timeline } from 'motion';

import { getIsMobile } from '../../helpers';

const SelectedFilters = props => {
  const overlay = useRef(null);
  const text = useRef(null);
  const svg = useRef(null);

  const onMouseEnter = (textElement, svgElement, overlayElement) => {
    if (getIsMobile()) return;
    const sequence = [
      [
        textElement,
        {
          opacity: [1, 0],
          transform: ['translate(0, 0)', 'translate(100px, 0)'],
          color: '#fff'
        },
        { duration: 0.15, delay: 0.05 }
      ],
      [
        textElement,
        {
          opacity: [0, 1],
          transform: ['translate(-100px, 0)', 'translate(0, 0)']
        },
        { at: 0.17 + 0.05 },
        { duration: 0.15, delay: 0.05 }
      ]
    ];

    timeline(sequence);

    animate(svgElement, { fill: '#fff' }, { duration: 0.7 });

    animate(
      overlayElement,
      { transform: ['skew(-45deg) scale(0, 1)', 'skew(-45deg) scale(2, 1)'] },
      { duration: 0.7 }
    );
  };

  const onMouseLeave = (textElement, svgElement, overlayElement) => {
    if (getIsMobile()) return;

    const sequence = [
      [
        textElement,
        {
          opacity: [1, 0],
          transform: ['translate(0, 0)', 'translate(-100px, 0)'],
          color: '#000'
        },
        { duration: 0.15, delay: 0.05 }
      ],
      [
        textElement,
        {
          opacity: [0, 1],
          transform: ['translate(100px, 0)', 'translate(0, 0)']
        },
        { at: 0.17 + 0.05 },
        { duration: 0.15, delay: 0.05 }
      ]
    ];

    timeline(sequence);

    animate(svgElement, { fill: '#1c1c1c' }, { duration: 0.7 });
    animate(
      overlayElement,
      { transform: 'skew(-45deg) scale(0, 1)' },
      { duration: 0.5 }
    );
  };

  const onMouseEnterSelectedFilter = event => {
    onMouseEnter(
      event.currentTarget.querySelector('.text'),
      event.currentTarget.querySelector('svg'),
      event.currentTarget.querySelector('.overlay')
    );
  };

  const onMouseLeaveSelectedFilter = event => {
    onMouseLeave(
      event.currentTarget.querySelector('.text'),
      event.currentTarget.querySelector('svg'),
      event.currentTarget.querySelector('.overlay')
    );
  };

  const compileFilters = () => {
    const arr = [];

    Object.keys(props.selected).forEach(key => {
      props.selected[key].forEach(f => {
        arr.push(
          <button
            key={`${key}-${f}`}
            onClick={() => {
              props.onRemove(key, f);
              const storage = window.sessionStorage[props.sessionStorageKey];
              const currentFilters = storage ? JSON.parse(storage) : {};
              const newFilters = Object.entries(currentFilters).reduce(
                (acc, [fKey, items]) => {
                  if (!acc[fKey]) {
                    acc[fKey] = items;
                  }

                  return {
                    ...acc,
                    [fKey]: acc[fKey].filter(item => item !== f)
                  };
                },
                {}
              );

              window.sessionStorage.setItem(
                props.sessionStorageKey,
                JSON.stringify(newFilters)
              );
            }}
            className="case-studies-results__applied-filter"
            onMouseEnter={onMouseEnterSelectedFilter}
            onMouseLeave={onMouseLeaveSelectedFilter}
          >
            <span className="text">
              {f}
              <svg>
                <use xlinkHref="#remove-filter" />
              </svg>
            </span>
            <span className="overlay"></span>
          </button>
        );
      });
    });

    return arr;
  };

  const filters = compileFilters();

  return (
    !!filters.length > 0 && (
      <div className="case-studies-results__applied-filters">
        {filters}
        <button
          onClick={() => {
            props.onClearAll();
            window.sessionStorage.removeItem(props.sessionStorageKey);
          }}
          onMouseEnter={() =>
            onMouseEnter(text.current, svg.current, overlay.current)
          }
          onMouseLeave={() =>
            onMouseLeave(text.current, svg.current, overlay.current)
          }
          className="case-studies-results__applied-filter case-studies-results__applied-filter--clear"
        >
          <span className="text" ref={text}>
            Clear All Filters
            <svg ref={svg}>
              <use xlinkHref="#remove-filter" />
            </svg>
          </span>
          <span className="overlay" ref={overlay}></span>
        </button>
      </div>
    )
  );
};

SelectedFilters.propTypes = {};

export default SelectedFilters;
